import React, { Fragment } from "react";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import StickyNote2Icon from "@mui/icons-material/StickyNote2";
import SaitDialog from "../atomic/SaitDialog";
import SaitButton from "../atomic/SaitButton";
import i18next from "../localization/i18n";

function NoteButton(props) {
	const [openWindow, setOpenWindow] = React.useState(false);

	return (
		<>
			<Tooltip
				title={
					<>
						<Typography fontSize={14} sx={{ fontWeight: "bold" }}>
							{props.title}:
						</Typography>
						<Typography fontSize={14}>{props.note}</Typography>
					</>
				}
			>
				<Box
					sx={{
						flexGrow: 1,
						display: "inline-flex",
						justifyContent: "center",
					}}
				>
					<IconButton
						onClick={(e) => {
							setOpenWindow(true);
						}}
					>
						<StickyNote2Icon color="primary" />
					</IconButton>
				</Box>
			</Tooltip>
			<SaitDialog
				open={openWindow}
				title={props.title}
				width="xs"
				content={<Typography align="center">{props.note}</Typography>}
				actions={
					<Fragment>
						<Box sx={{ flexGrow: 1 }} />
						<SaitButton text={i18next.t("close")} onClick={() => setOpenWindow(false)} />
						<Box sx={{ flexGrow: 1 }} />
					</Fragment>
				}
			/>
		</>
	);
}

/*
	Obbligatori:
		field
	Facoltativi:
		title
		headerName
		width
*/
export default function SaitNotesColumn(config) {
	return {
		headerName: config.headerName || config.title || "",
		field: config.field,
		width: config.width || 45,
		minWidth: 40,
		sortable: false,
		hidden: config.hidden || false,
		// disableColumnMenu: true,
		columnType: "notes",
		display: "flex",
		objmod: config.objmod,
		renderCell: (params) => {
			let note = params.row[config.field];
			if (note && (!config.conditionalRendering || config.conditionalRendering(params))) {
				return <NoteButton title={config.title} note={note} />;
			}
			return "";
		},
	};
}
